<ng-container *ngIf="state === 'not-provisioned'">
  <mat-divider></mat-divider>
  <section class="drawer-section">
    <p class="drawer-section-label">
      <mat-icon class="section-icon">manage_accounts</mat-icon>
      Azure AD Credentials
    </p>

    <div class="aad-status-row">
      <span class="aad-status-badge aad-status-badge--pending">Not Provisioned</span>
      <mat-spinner *ngIf="isProvisioning" diameter="18" class="aad-poll-spinner"></mat-spinner>
    </div>

    <!-- Operator-remote is read-only: show message instead of provision button -->
    <ng-container *ngIf="launchContext === 'operator-remote-vm'">
      <p class="aad-provision-hint">
        Cloud user account provisioning is managed by the participant. Contact them to provision their account.
      </p>
    </ng-container>

    <!-- For other contexts: show provision button -->
    <ng-container *ngIf="launchContext !== 'operator-remote-vm'">
      <p class="aad-provision-hint">
        A cloud user account template is attached but credentials have not been provisioned yet.
      </p>

      <p *ngIf="provisionError" class="aad-provision-error">{{ provisionError }}</p>

      <button mat-stroked-button color="primary"
              [disabled]="isProvisioning"
              (click)="provision()"
              class="aad-provision-btn">
        <mat-icon>person_add</mat-icon>
        {{ isProvisioning ? 'Provisioning…' : 'Provision' }}
      </button>
    </ng-container>
  </section>
</ng-container>
